/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InviteOptOutRouteImport } from './routes/invite-opt-out'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as EmailVerificationRouteImport } from './routes/email-verification'
import { Route as CheckEmailRouteImport } from './routes/check-email'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as KioskEncounterIdRouteImport } from './routes/kiosk.$encounterId'
import { Route as AuthenticatedTemplatesRouteImport } from './routes/_authenticated/templates'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPatientsRouteImport } from './routes/_authenticated/patients'
import { Route as AuthenticatedParallelClinicRouteImport } from './routes/_authenticated/parallel-clinic'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedFormsRouteImport } from './routes/_authenticated/forms'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedTemplatesIndexRouteImport } from './routes/_authenticated/templates.index'
import { Route as AuthenticatedSessionsIndexRouteImport } from './routes/_authenticated/sessions.index'
import { Route as AuthenticatedPatientsIndexRouteImport } from './routes/_authenticated/patients.index'
import { Route as AuthenticatedFormsIndexRouteImport } from './routes/_authenticated/forms.index'
import { Route as AuthenticatedTemplatesNewRouteImport } from './routes/_authenticated/templates.new'
import { Route as AuthenticatedTemplatesTemplateIdRouteImport } from './routes/_authenticated/templates.$templateId'
import { Route as AuthenticatedSessionsSessionIdRouteImport } from './routes/_authenticated/sessions.$sessionId'
import { Route as AuthenticatedPatientsNewRouteImport } from './routes/_authenticated/patients.new'
import { Route as AuthenticatedPatientsPatientIdRouteImport } from './routes/_authenticated/patients.$patientId'
import { Route as AuthenticatedBillingCheckoutRouteImport } from './routes/_authenticated/billing.checkout'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminTeamRouteImport } from './routes/_authenticated/admin.team'
import { Route as AuthenticatedAdminAuditLogsRouteImport } from './routes/_authenticated/admin.audit-logs'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteOptOutRoute = InviteOptOutRouteImport.update({
  id: '/invite-opt-out',
  path: '/invite-opt-out',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailVerificationRoute = EmailVerificationRouteImport.update({
  id: '/email-verification',
  path: '/email-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckEmailRoute = CheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskEncounterIdRoute = KioskEncounterIdRouteImport.update({
  id: '/kiosk/$encounterId',
  path: '/kiosk/$encounterId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTemplatesRoute = AuthenticatedTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPatientsRoute = AuthenticatedPatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedParallelClinicRoute =
  AuthenticatedParallelClinicRouteImport.update({
    id: '/parallel-clinic',
    path: '/parallel-clinic',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFormsRoute = AuthenticatedFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTemplatesIndexRoute =
  AuthenticatedTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTemplatesRoute,
  } as any)
const AuthenticatedSessionsIndexRoute =
  AuthenticatedSessionsIndexRouteImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsIndexRoute =
  AuthenticatedPatientsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPatientsRoute,
  } as any)
const AuthenticatedFormsIndexRoute = AuthenticatedFormsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedFormsRoute,
} as any)
const AuthenticatedTemplatesNewRoute =
  AuthenticatedTemplatesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedTemplatesRoute,
  } as any)
const AuthenticatedTemplatesTemplateIdRoute =
  AuthenticatedTemplatesTemplateIdRouteImport.update({
    id: '/$templateId',
    path: '/$templateId',
    getParentRoute: () => AuthenticatedTemplatesRoute,
  } as any)
const AuthenticatedSessionsSessionIdRoute =
  AuthenticatedSessionsSessionIdRouteImport.update({
    id: '/sessions/$sessionId',
    path: '/sessions/$sessionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsNewRoute =
  AuthenticatedPatientsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedPatientsRoute,
  } as any)
const AuthenticatedPatientsPatientIdRoute =
  AuthenticatedPatientsPatientIdRouteImport.update({
    id: '/$patientId',
    path: '/$patientId',
    getParentRoute: () => AuthenticatedPatientsRoute,
  } as any)
const AuthenticatedBillingCheckoutRoute =
  AuthenticatedBillingCheckoutRouteImport.update({
    id: '/billing/checkout',
    path: '/billing/checkout',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminTeamRoute = AuthenticatedAdminTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminAuditLogsRoute =
  AuthenticatedAdminAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/check-email': typeof CheckEmailRoute
  '/email-verification': typeof EmailVerificationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite-opt-out': typeof InviteOptOutRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/forms': typeof AuthenticatedFormsRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/parallel-clinic': typeof AuthenticatedParallelClinicRoute
  '/patients': typeof AuthenticatedPatientsRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRoute
  '/support': typeof AuthenticatedSupportRoute
  '/templates': typeof AuthenticatedTemplatesRouteWithChildren
  '/kiosk/$encounterId': typeof KioskEncounterIdRoute
  '/admin/audit-logs': typeof AuthenticatedAdminAuditLogsRoute
  '/admin/team': typeof AuthenticatedAdminTeamRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/billing/checkout': typeof AuthenticatedBillingCheckoutRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/patients/new': typeof AuthenticatedPatientsNewRoute
  '/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/templates/new': typeof AuthenticatedTemplatesNewRoute
  '/forms/': typeof AuthenticatedFormsIndexRoute
  '/patients/': typeof AuthenticatedPatientsIndexRoute
  '/sessions': typeof AuthenticatedSessionsIndexRoute
  '/templates/': typeof AuthenticatedTemplatesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/check-email': typeof CheckEmailRoute
  '/email-verification': typeof EmailVerificationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite-opt-out': typeof InviteOptOutRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/parallel-clinic': typeof AuthenticatedParallelClinicRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/support': typeof AuthenticatedSupportRoute
  '/kiosk/$encounterId': typeof KioskEncounterIdRoute
  '/admin/audit-logs': typeof AuthenticatedAdminAuditLogsRoute
  '/admin/team': typeof AuthenticatedAdminTeamRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/billing/checkout': typeof AuthenticatedBillingCheckoutRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/patients/new': typeof AuthenticatedPatientsNewRoute
  '/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/templates/new': typeof AuthenticatedTemplatesNewRoute
  '/forms': typeof AuthenticatedFormsIndexRoute
  '/patients': typeof AuthenticatedPatientsIndexRoute
  '/sessions': typeof AuthenticatedSessionsIndexRoute
  '/templates': typeof AuthenticatedTemplatesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/check-email': typeof CheckEmailRoute
  '/email-verification': typeof EmailVerificationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite-opt-out': typeof InviteOptOutRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/forms': typeof AuthenticatedFormsRouteWithChildren
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/parallel-clinic': typeof AuthenticatedParallelClinicRoute
  '/_authenticated/patients': typeof AuthenticatedPatientsRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_authenticated/templates': typeof AuthenticatedTemplatesRouteWithChildren
  '/kiosk/$encounterId': typeof KioskEncounterIdRoute
  '/_authenticated/admin/audit-logs': typeof AuthenticatedAdminAuditLogsRoute
  '/_authenticated/admin/team': typeof AuthenticatedAdminTeamRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/billing/checkout': typeof AuthenticatedBillingCheckoutRoute
  '/_authenticated/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/_authenticated/patients/new': typeof AuthenticatedPatientsNewRoute
  '/_authenticated/sessions/$sessionId': typeof AuthenticatedSessionsSessionIdRoute
  '/_authenticated/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/_authenticated/templates/new': typeof AuthenticatedTemplatesNewRoute
  '/_authenticated/forms/': typeof AuthenticatedFormsIndexRoute
  '/_authenticated/patients/': typeof AuthenticatedPatientsIndexRoute
  '/_authenticated/sessions/': typeof AuthenticatedSessionsIndexRoute
  '/_authenticated/templates/': typeof AuthenticatedTemplatesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/check-email'
    | '/email-verification'
    | '/forgot-password'
    | '/invite-opt-out'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/sso-callback'
    | '/verify-email'
    | '/admin'
    | '/forms'
    | '/home'
    | '/parallel-clinic'
    | '/patients'
    | '/settings'
    | '/support'
    | '/templates'
    | '/kiosk/$encounterId'
    | '/admin/audit-logs'
    | '/admin/team'
    | '/admin/users'
    | '/billing/checkout'
    | '/patients/$patientId'
    | '/patients/new'
    | '/sessions/$sessionId'
    | '/templates/$templateId'
    | '/templates/new'
    | '/forms/'
    | '/patients/'
    | '/sessions'
    | '/templates/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/check-email'
    | '/email-verification'
    | '/forgot-password'
    | '/invite-opt-out'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/sso-callback'
    | '/verify-email'
    | '/admin'
    | '/home'
    | '/parallel-clinic'
    | '/settings'
    | '/support'
    | '/kiosk/$encounterId'
    | '/admin/audit-logs'
    | '/admin/team'
    | '/admin/users'
    | '/billing/checkout'
    | '/patients/$patientId'
    | '/patients/new'
    | '/sessions/$sessionId'
    | '/templates/$templateId'
    | '/templates/new'
    | '/forms'
    | '/patients'
    | '/sessions'
    | '/templates'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/check-email'
    | '/email-verification'
    | '/forgot-password'
    | '/invite-opt-out'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/sso-callback'
    | '/verify-email'
    | '/_authenticated/admin'
    | '/_authenticated/forms'
    | '/_authenticated/home'
    | '/_authenticated/parallel-clinic'
    | '/_authenticated/patients'
    | '/_authenticated/settings'
    | '/_authenticated/support'
    | '/_authenticated/templates'
    | '/kiosk/$encounterId'
    | '/_authenticated/admin/audit-logs'
    | '/_authenticated/admin/team'
    | '/_authenticated/admin/users'
    | '/_authenticated/billing/checkout'
    | '/_authenticated/patients/$patientId'
    | '/_authenticated/patients/new'
    | '/_authenticated/sessions/$sessionId'
    | '/_authenticated/templates/$templateId'
    | '/_authenticated/templates/new'
    | '/_authenticated/forms/'
    | '/_authenticated/patients/'
    | '/_authenticated/sessions/'
    | '/_authenticated/templates/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CheckEmailRoute: typeof CheckEmailRoute
  EmailVerificationRoute: typeof EmailVerificationRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteOptOutRoute: typeof InviteOptOutRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  KioskEncounterIdRoute: typeof KioskEncounterIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite-opt-out': {
      id: '/invite-opt-out'
      path: '/invite-opt-out'
      fullPath: '/invite-opt-out'
      preLoaderRoute: typeof InviteOptOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-verification': {
      id: '/email-verification'
      path: '/email-verification'
      fullPath: '/email-verification'
      preLoaderRoute: typeof EmailVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-email': {
      id: '/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof CheckEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk/$encounterId': {
      id: '/kiosk/$encounterId'
      path: '/kiosk/$encounterId'
      fullPath: '/kiosk/$encounterId'
      preLoaderRoute: typeof KioskEncounterIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/templates': {
      id: '/_authenticated/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AuthenticatedTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients': {
      id: '/_authenticated/patients'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof AuthenticatedPatientsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/parallel-clinic': {
      id: '/_authenticated/parallel-clinic'
      path: '/parallel-clinic'
      fullPath: '/parallel-clinic'
      preLoaderRoute: typeof AuthenticatedParallelClinicRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/forms': {
      id: '/_authenticated/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AuthenticatedFormsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/templates/': {
      id: '/_authenticated/templates/'
      path: '/'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthenticatedTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedTemplatesRoute
    }
    '/_authenticated/sessions/': {
      id: '/_authenticated/sessions/'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof AuthenticatedSessionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/': {
      id: '/_authenticated/patients/'
      path: '/'
      fullPath: '/patients/'
      preLoaderRoute: typeof AuthenticatedPatientsIndexRouteImport
      parentRoute: typeof AuthenticatedPatientsRoute
    }
    '/_authenticated/forms/': {
      id: '/_authenticated/forms/'
      path: '/'
      fullPath: '/forms/'
      preLoaderRoute: typeof AuthenticatedFormsIndexRouteImport
      parentRoute: typeof AuthenticatedFormsRoute
    }
    '/_authenticated/templates/new': {
      id: '/_authenticated/templates/new'
      path: '/new'
      fullPath: '/templates/new'
      preLoaderRoute: typeof AuthenticatedTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedTemplatesRoute
    }
    '/_authenticated/templates/$templateId': {
      id: '/_authenticated/templates/$templateId'
      path: '/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedTemplatesRoute
    }
    '/_authenticated/sessions/$sessionId': {
      id: '/_authenticated/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof AuthenticatedSessionsSessionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/new': {
      id: '/_authenticated/patients/new'
      path: '/new'
      fullPath: '/patients/new'
      preLoaderRoute: typeof AuthenticatedPatientsNewRouteImport
      parentRoute: typeof AuthenticatedPatientsRoute
    }
    '/_authenticated/patients/$patientId': {
      id: '/_authenticated/patients/$patientId'
      path: '/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AuthenticatedPatientsPatientIdRouteImport
      parentRoute: typeof AuthenticatedPatientsRoute
    }
    '/_authenticated/billing/checkout': {
      id: '/_authenticated/billing/checkout'
      path: '/billing/checkout'
      fullPath: '/billing/checkout'
      preLoaderRoute: typeof AuthenticatedBillingCheckoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/team': {
      id: '/_authenticated/admin/team'
      path: '/team'
      fullPath: '/admin/team'
      preLoaderRoute: typeof AuthenticatedAdminTeamRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/audit-logs': {
      id: '/_authenticated/admin/audit-logs'
      path: '/audit-logs'
      fullPath: '/admin/audit-logs'
      preLoaderRoute: typeof AuthenticatedAdminAuditLogsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAuditLogsRoute: typeof AuthenticatedAdminAuditLogsRoute
  AuthenticatedAdminTeamRoute: typeof AuthenticatedAdminTeamRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAuditLogsRoute: AuthenticatedAdminAuditLogsRoute,
  AuthenticatedAdminTeamRoute: AuthenticatedAdminTeamRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedFormsRouteChildren {
  AuthenticatedFormsIndexRoute: typeof AuthenticatedFormsIndexRoute
}

const AuthenticatedFormsRouteChildren: AuthenticatedFormsRouteChildren = {
  AuthenticatedFormsIndexRoute: AuthenticatedFormsIndexRoute,
}

const AuthenticatedFormsRouteWithChildren =
  AuthenticatedFormsRoute._addFileChildren(AuthenticatedFormsRouteChildren)

interface AuthenticatedPatientsRouteChildren {
  AuthenticatedPatientsPatientIdRoute: typeof AuthenticatedPatientsPatientIdRoute
  AuthenticatedPatientsNewRoute: typeof AuthenticatedPatientsNewRoute
  AuthenticatedPatientsIndexRoute: typeof AuthenticatedPatientsIndexRoute
}

const AuthenticatedPatientsRouteChildren: AuthenticatedPatientsRouteChildren = {
  AuthenticatedPatientsPatientIdRoute: AuthenticatedPatientsPatientIdRoute,
  AuthenticatedPatientsNewRoute: AuthenticatedPatientsNewRoute,
  AuthenticatedPatientsIndexRoute: AuthenticatedPatientsIndexRoute,
}

const AuthenticatedPatientsRouteWithChildren =
  AuthenticatedPatientsRoute._addFileChildren(
    AuthenticatedPatientsRouteChildren,
  )

interface AuthenticatedTemplatesRouteChildren {
  AuthenticatedTemplatesTemplateIdRoute: typeof AuthenticatedTemplatesTemplateIdRoute
  AuthenticatedTemplatesNewRoute: typeof AuthenticatedTemplatesNewRoute
  AuthenticatedTemplatesIndexRoute: typeof AuthenticatedTemplatesIndexRoute
}

const AuthenticatedTemplatesRouteChildren: AuthenticatedTemplatesRouteChildren =
  {
    AuthenticatedTemplatesTemplateIdRoute:
      AuthenticatedTemplatesTemplateIdRoute,
    AuthenticatedTemplatesNewRoute: AuthenticatedTemplatesNewRoute,
    AuthenticatedTemplatesIndexRoute: AuthenticatedTemplatesIndexRoute,
  }

const AuthenticatedTemplatesRouteWithChildren =
  AuthenticatedTemplatesRoute._addFileChildren(
    AuthenticatedTemplatesRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedFormsRoute: typeof AuthenticatedFormsRouteWithChildren
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedParallelClinicRoute: typeof AuthenticatedParallelClinicRoute
  AuthenticatedPatientsRoute: typeof AuthenticatedPatientsRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
  AuthenticatedTemplatesRoute: typeof AuthenticatedTemplatesRouteWithChildren
  AuthenticatedBillingCheckoutRoute: typeof AuthenticatedBillingCheckoutRoute
  AuthenticatedSessionsSessionIdRoute: typeof AuthenticatedSessionsSessionIdRoute
  AuthenticatedSessionsIndexRoute: typeof AuthenticatedSessionsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedFormsRoute: AuthenticatedFormsRouteWithChildren,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedParallelClinicRoute: AuthenticatedParallelClinicRoute,
  AuthenticatedPatientsRoute: AuthenticatedPatientsRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedTemplatesRoute: AuthenticatedTemplatesRouteWithChildren,
  AuthenticatedBillingCheckoutRoute: AuthenticatedBillingCheckoutRoute,
  AuthenticatedSessionsSessionIdRoute: AuthenticatedSessionsSessionIdRoute,
  AuthenticatedSessionsIndexRoute: AuthenticatedSessionsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CheckEmailRoute: CheckEmailRoute,
  EmailVerificationRoute: EmailVerificationRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteOptOutRoute: InviteOptOutRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  KioskEncounterIdRoute: KioskEncounterIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
